module.exports = __webpack_public_path__ + "img/anti-fraud-notice.b055f6e5.png";